import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';

@Component({
  selector: 'app-webapp-manager',
  templateUrl: './webapp-manager.component.html',
  styleUrls: ['./webapp-manager.component.css']
})
export class WebappManagerComponent implements OnInit {

  userSelected;
  userSelectedData;
  config1 = {
    id: null,
      tableName: 'userAppSession',
      cacheLabel: null,
      tableProperties: [
        {
            "columnName": "id",
            "dataType": "int"
        },
        {
            "columnName": "username",
            "dataType": "varchar"
        },
        {
          "columnName": "password",
          "dataType": "varchar"
        },
        {
            "columnName": "token",
            "dataType": "varchar"
        },
        {
            "columnName": "logged",
            "dataType": "tinyint"
        },
        {
            "columnName": "role",
            "dataType": "varchar"
        },
        {
            "columnName": "FK_ID_clientDetails",
            "dataType": "int"
        }
    ],
      table1: '',
      table2: '',
      tableX: '',
      FK_1: '',
      FK_2: '',
      FK_1_value: null,
      FK_2_value: null,
      queryName: '',
      hiddenInputFields: [
      ],
      preloadedValues: [
      ],
      mandatoryFields: [],
      currentId: null,
      showCreateUpdateButtons: true
  };
  config2 = {
    id: null,
      tableName: 'appXclient',
      cacheLabel: null,
      tableProperties: [
        {
            "columnName": "active",
            "dataType": "tinyint"
        },
        {
            "columnName": "visible",
            "dataType": "tinyint"
        },
        {
          "columnName": "FK_ID_userApp",
          "dataType": "int"
        },
        {
            "columnName": "FK_ID_clientDetails",
            "dataType": "int"
        }
    ],
      table1: '',
      table2: '',
      tableX: '',
      FK_1: '',
      FK_2: '',
      FK_1_value: null,
      FK_2_value: null,
      queryName: '',
      hiddenInputFields: [
      ],
      mandatoryFields: [],
      currentId: null,
      showCreateUpdateButtons: true
  }

  constructor(private resolver: ResolverService,private commonFunctions: FunctionsService,private router: Router) { }

  ngOnInit(): void {
    this.resolver.getClientAppList(true);
    this.initCrud(this.config1);
  }

  initCrud(config){
    // REFACTOR : ojo que las funciones de create dependen de quien elija en el FK_1 y en el FK_2 a uno le pone el currentId al otro el insertado FK
    
    //config.id = config && config.id? config.id : this.crudFieldsData.generateRandomNumber();
    config.cacheLabel = ''+ this.commonFunctions.getSelectedClientId();
    config.currentId = this.commonFunctions.getSelectedClientId();
  }

  getClientAppList(){
    if(this.resolver.getDependency('getClientAppList') && this.resolver.getDependency('getClientAppList')['records']){
      return this.resolver.getDependency('getClientAppList') && this.resolver.getDependency('getClientAppList')['records'];
    }else{
      return [];
    }
  }

  reload(){
    this.resolver.getClientAppList(true);
  }

  reloadThisClientApps(){
    this.resolver.getBackendDataForQueryId('getThisClientApps',true,this.commonFunctions.getSelectedClientId());
  }

  isLoading(){
    return this.resolver.isLoading('getClientAppList');
  }

  isLoadingUserApps(){
    return this.resolver.isLoading('getThisClientApps');
  }

  selectUser(row){
    debugger
    this.userSelected = row;
    this.commonFunctions.setSelectedClientId(row.FK_ID_clientDetails);
    this.initCrud(this.config2);
    if(this.resolver.getDependency('getThisClientApps') && this.resolver.getDependency('getThisClientApps')['records']){
      this.userSelectedData = this.commonFunctions.arrayHasElementByLabel(this.resolver.getDependency('getThisClientApps')['records'], 'FK_ID_clientDetails',row.FK_ID_clientDetails);
    }else{
      return [];
    }
  }


  goBack(){
    this.userSelected = null;
  }

  goToCrudView(table){
/*     sidenav.toggle(); */
    this.router.navigateByUrl('crud/'+table);
  }

  onSlideToggleEvent(event,prop){
    debugger
    switch(prop){
      case 'username':
          if(event.checked){
            this.config1.preloadedValues.push(
              {username: 'tucojb@email.com'}
            );
          }else{
            debugger
          }
        break;
      case 'password':
        if(event.checked){
          this.config1.preloadedValues.push(
            {password: '1234'}
          );
        }else{
          debugger
        }
      }
      this.initCrud(this.config1);
  }
}
